<template>
  <v-card
    class="rounded-lg overflow-hidden item"
    color="transparent"
    :to="text ? to : ''"
    flat
  >
    <img
      class="d-block item-img"
      :src="files + img_home + '?resize=1&w=400'"
      :alt="title"
      width="100%"
      height="100%"
    />

    <div class="d-flex flex-column justify-end item-content">
      <div class="px-4 px-md-7 item-content-bg">
        <div
          class="
            white--text
            text-h6 text-md-h5 text-lg-h4 text-center
            font-weight-bold
            mt-4
          "
        >
          {{ title }}
        </div>

        <div class="mb-n6 item-hover">
          <div
            v-if="introduction"
            class="white--text text-body-1 text-center font-weight-regular mt-3"
            v-html="introduction"
          ></div>

          <div v-if="text" class="d-flex justify-center">
            <v-btn
              class="white--text text-body-2 text-none font-weight-bold mt-1"
              :to="to"
              text
            >
              Saiba Mais
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    img_home: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    introduction: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    hover: false,
  }),
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 9 / 16;
    object-fit: cover;
  }

  &-content {
    bottom: 0;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: all 0.1s linear;

    &-bg {
      background: rgb(0, 0, 0);
      background: -moz-linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0,
        rgba(0, 0, 0, 0) 100%
      );
      background: -webkit-linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0,
        rgba(0, 0, 0, 0) 100%
      );
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 1) 0,
        rgba(0, 0, 0, 0) 100%
      );
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#000000",GradientType=1);
      padding-bottom: 52px;
      padding-top: 120px;
      pointer-events: initial;
    }
  }

  &-hover {
    max-height: 0;
    overflow: hidden;
    transition: none;
  }

  &:hover {
    .item-hover {
      max-height: 500px;
      transition: all 0.3s linear;
    }
  }
}
</style>
